<template>
  <div 
    class="fts-automation-node-if-else automation-node" 
    :class="{ 
      'automation-node--debug': data.debug, 
      'automation-node--debugging': isDebugging,   
    }"
  >
    <fts-automation-block-number :data="data" />

    <div class="node-content">
      <div class="node-content-icon node-content-icon--condition">
        <i class="fts-icon-automation-condition" />
      </div>

      <div class="node-content-wrapper">
        <fts-formula
          v-model="data.condition"
          :variables="data.variables"
          @input="updateData"
        />
      </div>

      <div class="node-content-debug">
        <fts-automation-debugpoint
          v-model="data.debug"
          class="node-header__debugpoint"
          @input="updateData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { automationDesignStore } from "../../store/automationDesignStore";

import FTSFormula from "../../design/FTSFormula.vue";
import FTSAutomationDebugpoint from "./FTSAutomationDebugpoint";
import FTSAutomationBlockNumber from "./FTSAutomationBlockNumber";

export default {
  props: {
    data: Object,
    inputs: Array,
    information: Array,
  },
  components: {
    "fts-formula": FTSFormula,
    "fts-automation-debugpoint": FTSAutomationDebugpoint,
    "fts-automation-block-number": FTSAutomationBlockNumber,
  },
  data() {
    return {
      editor: null,
      show: -1,
      content: "",
      isDebugging: false,
    };
  },
  methods: {
    updateData() {
      this.$forceUpdate();
    },
    refreshBlockState() {
      this.isDebugging = false;
      if (automationDesignStore.state.debugPayload && automationDesignStore.state.debugPayload.nodeId) {
        let nodeId = automationDesignStore.state.debugPayload.nodeId;
        let diagram = automationDesignStore.state.diagram;
        /* the debugged node may have been deleted since the payload was captured */
        if (diagram && diagram[nodeId] && diagram[nodeId].data.id == this.data.id) {
          this.isDebugging = true;
        }
      }

      this.$forceUpdate();
    },
  },
  computed: {
    variables() {
      return automationDesignStore.state.variables;
    },
  },
  mounted() {
    window.eventBus.$on("refreshAutomationBlocks", this.refreshBlockState);
  },
  beforeDestroy() {
    /* this handler only — a bare $off would strip every other block's listener too */
    window.eventBus.$off("refreshAutomationBlocks", this.refreshBlockState);
  },
};
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars.scss" as *;

.fts-automation-node-if-else {
  padding: 0.75rem;
  outline: 2px solid rgba(var(--fts-block-condition-background-rgb), 0.3);
}
</style>